import dayjs from "dayjs";
import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const yearOptions = _.times(10, (index) => {
    return dayjs().subtract(index + 1, "year").format("YYYY");
});

const initState = {
    selectedYear: dayjs().subtract(1, "year").format("YYYY"), // 选中的年份
    selectedUnitIds: null, // 选中的科室
    unitsMap: null, // 科室map
    keyword: "", // 搜索关键词
    pageable: {
        current: 1, // 分页
    },
    users: null, // 表格数据
    tableLoading: false, // 表格数据加载
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,

    yearOptions,
};
export default viewModel;
